<template>
  <main-layout>
    <!--chart :options="line" ref="line" theme="ovilia-green" auto-resize></chart>
    <chart :options="bar" ref="bar" theme="ovilia-green" auto-resize></chart-->
    <chart :options="pie" ref="pie"></chart>
  </main-layout>
</template>

<script>
  import MainLayout from '../layouts/Main.vue'
  import auth from '../auth'
  console.log("auth:%o", auth)

  export default {
    data () {
      return {

        openid: '',
        token: '',
        community: '',
        reqHouseAreaUrl: 'https://alphago.chemucao.cn/real/index.php/community/deal?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&community=',
        respData: {}, //{"brief":{"id":"2225","name":"\u5bcc\u529b\u53c8\u4e00\u57ceC\u533a","code":"1111027374303","district":"\u671d\u9633","bizcycle":"\u8c46\u5404\u5e84","subway":"","school":"","link":"http:\/\/bj.lianjia.com\/xiaoqu\/1111027374303\/","crawl":"1"},"price":{"2012-01":18651,"2012-02":17529,"2012-03":18867,"2012-04":19177,"2012-05":19029,"2012-06":19749,"2012-07":21164,"2012-08":20629,"2012-09":20775,"2012-10":20743,"2012-11":21334,"2012-12":22820,"2013-01":24564,"2013-02":25208,"2013-03":25751,"2013-04":26203,"2013-05":25440,"2013-06":26138,"2013-07":27368,"2013-08":28528,"2013-09":28070,"2013-10":31169,"2013-11":32234,"2013-12":30627,"2014-01":28106,"2014-02":32686,"2014-03":17059,"2014-04":28728,"2014-05":28283,"2014-06":17220,"2014-07":27299,"2014-08":28903,"2014-09":27930,"2014-10":27820,"2014-11":25681,"2014-12":26122,"2015-01":27133,"2015-02":18210,"2015-03":26009,"2015-04":26527,"2015-05":26383,"2015-06":26843,"2015-07":27790,"2015-08":27329,"2015-09":26213,"2015-10":30293,"2015-11":31336,"2015-12":30670,"2016-01":29522,"2016-02":32475,"2016-03":36420,"2016-04":33336,"2016-05":32438,"2016-06":39905,"2016-07":41910,"2016-08":42723,"2016-09":52324,"2016-10":48013,"2016-11":46574,"2016-12":52019},"count":{"2012-01":"3","2012-02":"10","2012-03":"8","2012-04":"2","2012-05":"6","2012-06":"13","2012-07":"4","2012-08":"8","2012-09":"7","2012-10":"3","2012-11":"10","2012-12":"12","2013-01":"14","2013-02":"12","2013-03":"10","2013-04":"4","2013-05":"7","2013-06":"10","2013-07":"7","2013-08":"9","2013-09":"5","2013-10":"7","2013-11":"2","2013-12":"5","2014-01":"7","2014-02":"8","2014-03":"2","2014-04":"5","2014-05":"2","2014-06":"4","2014-07":"2","2014-08":"6","2014-09":"2","2014-10":"12","2014-11":"5","2014-12":"5","2015-01":"4","2015-02":"4","2015-03":"13","2015-04":"26","2015-05":"18","2015-06":"20","2015-07":"25","2015-08":"24","2015-09":"18","2015-10":"16","2015-11":"18","2015-12":"25","2016-01":"26","2016-02":"20","2016-03":"16","2016-04":"10","2016-05":"11","2016-06":"14","2016-07":"22","2016-08":"28","2016-09":"12","2016-10":"4","2016-11":"7","2016-12":"5"},"bedroom":[{"count":"154","bedroom":"1"},{"count":"576","bedroom":"2"},{"count":"70","bedroom":"3"},{"count":"12","bedroom":"4"},{"count":"2","bedroom":"5"}],"bj_price":{"2012-01":21839,"2012-02":22211,"2012-03":23095,"2012-04":24041,"2012-05":24647,"2012-06":25361,"2012-07":26366,"2012-08":26898,"2012-09":27274,"2012-10":27332,"2012-11":28157,"2012-12":29133,"2013-01":30690,"2013-02":32003,"2013-03":33865,"2013-04":33133,"2013-05":34367,"2013-06":35303,"2013-07":36181,"2013-08":36864,"2013-09":37670,"2013-10":37891,"2013-11":38804,"2013-12":38340,"2014-01":37917,"2014-02":39504,"2014-03":39241,"2014-04":39384,"2014-05":37713,"2014-06":35984,"2014-07":35823,"2014-08":35346,"2014-09":35017,"2014-10":37112,"2014-11":36586,"2014-12":36712,"2015-01":36589,"2015-02":36359,"2015-03":36723,"2015-04":38059,"2015-05":38556,"2015-06":37368,"2015-07":38381,"2015-08":38841,"2015-09":39495,"2015-10":39595,"2015-11":39742,"2015-12":40617,"2016-01":42047,"2016-02":42198,"2016-03":44460,"2016-04":45728,"2016-05":46748,"2016-06":47373,"2016-07":49900,"2016-08":53037,"2016-09":58526,"2016-10":59899,"2016-11":60644,"2016-12":64706},"bj_count":{"2012-01":870,"2012-02":2792,"2012-03":3364,"2012-04":2994,"2012-05":3549,"2012-06":4238,"2012-07":3834,"2012-08":3150,"2012-09":3010,"2012-10":3513,"2012-11":4113,"2012-12":5526,"2013-01":4867,"2013-02":2595,"2013-03":7342,"2013-04":1952,"2013-05":3135,"2013-06":3340,"2013-07":3207,"2013-08":4104,"2013-09":3934,"2013-10":3180,"2013-11":2399,"2013-12":2691,"2014-01":2325,"2014-02":1703,"2014-03":2472,"2014-04":2153,"2014-05":1912,"2014-06":2240,"2014-07":2765,"2014-08":3296,"2014-09":2687,"2014-10":6077,"2014-11":4099,"2014-12":3593,"2015-01":3778,"2015-02":2142,"2015-03":6322,"2015-04":7241,"2015-05":6771,"2015-06":6687,"2015-07":6264,"2015-08":6441,"2015-09":5154,"2015-10":5794,"2015-11":6965,"2015-12":9828,"2016-01":9437,"2016-02":7164,"2016-03":12288,"2016-04":6240,"2016-05":6605,"2016-06":6906,"2016-07":9472,"2016-08":12702,"2016-09":11126,"2016-10":3659,"2016-11":4319,"2016-12":3216},"bj_bedroom":[{"count":"21987","bedroom":""},{"count":"78","bedroom":"--"},{"count":"43","bedroom":"0"},{"count":"92937","bedroom":"1"},{"count":"178924","bedroom":"2"},{"count":"74127","bedroom":"3"},{"count":"8087","bedroom":"4"},{"count":"1133","bedroom":"5"},{"count":"218","bedroom":"6"},{"count":"29","bedroom":"7"},{"count":"14","bedroom":"8"},{"count":"6","bedroom":"9"}]},



        line:{
          title: {
            text: '成交价格',
            left: 'center',
            textStyle: {
              color: '#999'
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            top: 25,
            data:['phpdata','北京']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              dataZoom: {yAxisIndex: 'none'},
              dataView: {readOnly: false},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name:'phpdata',
              type:'line',
              data:['phpdata']
            },
            {
              name:'北京',
              type:'line',
              data:['phpdata']
            }
          ]
        },

        bar:{
          title: {
              text: '成交数量',
              left: 'center',
              textStyle: {
                  color: '#999'
              }
          },
          tooltip: {
              trigger: 'axis'
          },
          legend: {
              top: 25,
              data:['phpdata','北京']
          },
          grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
          },
          toolbox: {
              feature: {
                  dataZoom: {yAxisIndex: 'none'},
                  dataView: {readOnly: false},
                  saveAsImage: {}
              }
          },
          xAxis: {
              type: 'category',
              boundaryGap: true,
              data: ['phpdata']
          },
          yAxis: {
              type: 'value'
          },
          series: [
              {
                  name:'phpdata',
                  type:'bar',
                  data:['phpdata']
              },
              {
                  name:'北京',
                  type:'bar',
                  data:['phpdata']
              }
          ]
        },

        pie:
        {
          title: {
            text: '成交户型分布',
            left: 'center',
            textStyle: {
              color: '#999'
            }
          },
          legend: {
            top: 25,
            data:['phpdata','北京']
          },
          toolbox: {
            feature: {
              dataZoom: {yAxisIndex: 'none'},
              dataView: {readOnly: false},
              saveAsImage: {}
            }
          },
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          series : [
            {
              name:'北京',
              type:'pie',
              radius : '55%',
              center: ['75%', '50%'],
              data:['phpdata'],
              roseType: 'angle',
              labelLine: {
                normal: {
                  lineStyle: {
                    color: 'rgba(2, 2, 30, 0.3)'
                  },
                  smooth: 0.2,
                  length: 10,
                  length2: 20
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgba(2, 26, 81, 0.8)',
                  shadowBlur: 200,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            },
            {
              name:'phpdata',
              type:'pie',
              radius : '55%',
              center: ['25%', '50%'],
              data:['phpdata'],
              roseType: 'angle',
              labelLine: {
                normal: {
                  lineStyle: {
                    color: 'rgba(2, 2, 30, 0.3)'
                  },
                  smooth: 0.2,
                  length: 10,
                  length2: 20
                }
              },
              itemStyle: {
                normal: {
                  color: '#c23531',
                  shadowBlur: 200,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }

      }

    },
    methods: {
      load() {
        console.log("this.respData:%o", this.respData)
        // let bedroom = [{"count":"154","bedroom":"1"},{"count":"576","bedroom":"2"},{"count":"70","bedroom":"3"},{"count":"12","bedroom":"4"},{"count":"2","bedroom":"5"}]
        let bedroom = this.respData.bedroom

        // let bj_bedroom = [{"count":"21987","bedroom":""},{"count":"78","bedroom":"--"},{"count":"43","bedroom":"0"},{"count":"92937","bedroom":"1"},{"count":"178924","bedroom":"2"},{"count":"74127","bedroom":"3"},{"count":"8087","bedroom":"4"},{"count":"1133","bedroom":"5"},{"count":"218","bedroom":"6"},{"count":"29","bedroom":"7"},{"count":"14","bedroom":"8"},{"count":"6","bedroom":"9"}]
        let bj_bedroom = this.respData.bj_bedroom

        //let brief = {"id":"2225","name":"\u5bcc\u529b\u53c8\u4e00\u57ceC\u533a","code":"1111027374303","district":"\u671d\u9633","bizcycle":"\u8c46\u5404\u5e84","subway":"","school":"","link":"http:\/\/bj.lianjia.com\/xiaoqu\/1111027374303\/","crawl":"1"}
        let brief = this.respData.brief


        console.log("updateChart...bedroom:%o", bedroom)
        var at=[]
        var as=[]
        for (let key in bedroom) {
          let name = bedroom[key]['bedroom'] + "居室"
          let value = bedroom[key]['count']
          value = {value:value, name:name}
          at.push(name)
          as.push(value)
          console.log("name:%s, value:%s", name, value)
        }

        console.log("updateChart...bj_bedroom:%o", bj_bedroom)
        var bat=[]
        var bas=[]
        for (let key in bj_bedroom) {
          let name = bj_bedroom[key]['bedroom'] + "居室"
          let value = bj_bedroom[key]['count']
          value = {value:value, name:name}
          bat.push(name)
          bas.push(value)
          console.log("name:%s, value:%s", name, value)
        }

        let n = []
        n.push(brief.name)
        n.push("北京")
        console.log("n:%o", n)
        let asyncData = {
          name: n,
          categories: at,
          data: as
        }

        let bjasyncData = {
          categories: bat,
          data: bas
        }

        console.log("load...asyncData:%o", asyncData)
        console.log("load...bjasyncData:%o", bjasyncData)

        this.$refs.pie.mergeOptions({
          legend: {
            top: 25,
            data:asyncData.name
          },
          series: [
            {
              name: asyncData.name[0],
              data: asyncData.data
            },
            {
              name: asyncData.name[1],
              data: bjasyncData.data
            }

          ]
        })



      },
      reqApiData: function(community){
        console.info("community:%s", community);
        var url = this.reqHouseAreaUrl + community;
        console.debug("reqHouseArea url:%s", url);
        // this.$http.post(this.testUrl, this.testData).then((response) => {
        this.$http.post(url, {foo:"bar"}).then((response) => {
          console.info("PASS! response:%o", response);
          console.log("status%s", response.status);
          console.log("statusText:%s", response.statusText);
          console.log("Expires: %s", response.headers.get('Expires'));
          console.log("body: %o", response.body);
          this.respData = response.body.data
          this.load()

        }, (response) => {
          // error callback
          console.error("FAIL!!! response:%o", response);
        });
      },
      updateChart: function(data){
        /*{"count":"154","bedroom":"1"},{"count":"576","bedroom":"2"},{"count":"70","bedroom":"3"},{"count":"12","bedroom":"4"},{"count":"2","bedroom":"5"}*/
        data = [{"count":"154","bedroom":"1"},{"count":"576","bedroom":"2"},{"count":"70","bedroom":"3"},{"count":"12","bedroom":"4"},{"count":"2","bedroom":"5"}]
        console.log("updateChart...data:%o", data)
        var at = new Array()
        var as = new Array()
        let asyncData = {
          categories: at,
          data: as
        }

        for (var x in data)
        {
          console.log("x:%s, data:%o", x, data[x])
          var tn = data[x]["bedroom"] + "居室"
          at.push(tn)
          var ass = '{"value":"' + data[x]["count"] + '","name":"' + tn + '"}'
          as.push(ass)
        }
        console.log("at:%o, as:%o", at, as)
        console.log("this.$refs.pie:%o", this.$refs.pie)
        /*this.$refs.pie.mergeOptions({
          xAxis: {
            data: at
          },
          series: [{
            data: as
          }]
        })*/
        return asyncData
      }
    },
    beforeCreate (){
      console.log("beforeCreate...")
    },
    created (){
      console.log("created...")
      console.log('get openid:%s', auth.getOpenid())
      console.log('get community:%s', auth.getCm())
      console.log('get token:%s', auth.getToken())
      this.community = auth.getCm()
      console.log("community:%s", this.community)
      this.reqApiData(this.community)
      // console.log("this.pie:%o", this.pie);
      //console.log("this.respData:%o", this.respData)
    },
    beforeMount (){
      console.log("beforeMount...")
    },
    mounted (){
      console.log("mounted...")
      //let res = this.updateChart(null)
      //console.log("res:%o", res)

    },
    beforeUpdate (){
      console.log("beforeUpdate...")
    },
    updated (){
      console.log("updated...")
    },
    activated (){
      console.log("activated...")
    },
    deactivated (){
      console.log("deactivated...")
    },
    beforeDestory (){
      console.log("beforeDestory...")
    },
    destroyed (){
      console.log("destroyed...")
    },
    components: {
      MainLayout
    }

  }
</script>

<style>
.echarts {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// Htype.vue?4e8adc4e